import api from './api';
import uploadService from './upload.service';

class AvatarService {
    fetch(avatarLink){
        if(avatarLink == undefined){
            return;
        } else if(avatarLink == "default"){
            localStorage.removeItem("avatar");
        } else {
            uploadService.getFile(avatarLink)
            .then( response => new Blob([response.data]) )
            .then( blob => new Promise( callback =>{
                let reader = new FileReader() ;
                reader.onload = function(){ callback(this.result) } ;
                reader.readAsDataURL(blob) ;
            }) ).then( dataUri => 
                localStorage.setItem("avatar", dataUri) ) ;
        }
    }

    get(){
        if(localStorage.getItem("avatar") === null){
            return "/static/mock-images/avatars/avatar_default.jpg";
        } 
        return localStorage.getItem("avatar");
    }
}

export default new AvatarService();